import { cn } from "@/lib/utils";
import { Button } from "@patient-watch/ui/button";
import { ArrowUpDown } from "lucide-react";

interface AdminColumnSortHeaderProps {
    label: string;
    onClick: () => void;
    className?: string;
}

/** Ghost header button + ArrowUpDown (templates / admin users / patients pattern). */
export function AdminColumnSortHeader({ label, onClick, className }: AdminColumnSortHeaderProps) {
    return (
        <Button type="button" variant="ghost" size="sm" className={cn("-ml-3 h-8", className)} onClick={onClick}>
            {label}
            <ArrowUpDown className="opacity-70 ml-2 w-4 h-4 shrink-0" />
        </Button>
    );
}
